import {
  CurrencyStringDollars,
  FormattedMessage,
} from '@b-stock/fe-core/bstock-react'

import { BetterOddsBidderCount } from '@/components/betterOdds/BetterOddsBidderCount'
import AuctionCard from '@/components/common/auctionCard/AuctionCard'
import type { SearchResult } from '@/queries/listingSearchQuery'

type Props = {
  listing: SearchResult
  position: number
}

export default function WinOpportunitiesCard({ listing, position }: Props) {
  // `|| 0` matches ListingCard's currentPrice fallback: winningBidAmount is
  // optional on the search doc, and Number(undefined) is NaN.
  const currentBid = Number(listing.winningBidAmount) || 0
  // maxBidQuantity=2 means 0-bid listings are valid results here — suppress
  // the line rather than show a contradictory "Current bid $0.00" next to
  // BetterOddsBidderCount's "No bidders yet".
  const hasBid = currentBid > 0

  return (
    <AuctionCard
      listing={listing}
      carousel_name="win-opportunities"
      screenName="homepage"
      position={position}
      extra={
        <>
          {hasBid && (
            <>
              <FormattedMessage id="Auction.status.currentBid" />{' '}
              <strong data-testid="win-opportunities-current-bid">
                <CurrencyStringDollars
                  currency={listing.currency}
                  value={currentBid}
                />
              </strong>
              {' · '}
            </>
          )}
          <BetterOddsBidderCount listing={listing} />
        </>
      }
    />
  )
}
